export interface InvoiceLetterhead {
  company_name: string | null;
  street: string | null;
  postal_code: string | null;
  city: string | null;
  country: string | null;
  tax_id: string | null;
  email: string | null;
  iban: string | null;
  bic: string | null;
  logo_url: string | null;
  favicon_url: string | null;
  footer_text: string | null;
  letterhead_pdf_data: string | null;
}

export type InvoiceLetterheadForm = {
  [K in keyof InvoiceLetterhead]: string;
};

export function letterheadFromApi(lh: InvoiceLetterhead): InvoiceLetterheadForm {
  return {
    company_name: lh.company_name ?? "",
    street: lh.street ?? "",
    postal_code: lh.postal_code ?? "",
    city: lh.city ?? "",
    country: lh.country ?? "",
    tax_id: lh.tax_id ?? "",
    email: lh.email ?? "",
    iban: lh.iban ?? "",
    bic: lh.bic ?? "",
    logo_url: lh.logo_url ?? "",
    favicon_url: lh.favicon_url ?? "",
    footer_text: lh.footer_text ?? "",
    letterhead_pdf_data: lh.letterhead_pdf_data ?? "",
  };
}

export const EMPTY_LETTERHEAD: InvoiceLetterheadForm = {
  company_name: "",
  street: "",
  postal_code: "",
  city: "",
  country: "",
  tax_id: "",
  email: "",
  iban: "",
  bic: "",
  logo_url: "",
  favicon_url: "",
  footer_text: "",
  letterhead_pdf_data: "",
};
